import React, {Component} from 'react';
import {images} from 'assets/img/dashboard/buy-and-sell/buy-and-sell';
import {MoneyField} from "buenLib/components/MoneyField";
import 'assets/sass/dashboard/buy-and-sell/Balances.scss';
import { AppContext } from 'app/state/AppContext';

export class BalanceItem extends Component {
    static contextType = AppContext;

    render() {
        const { getCurrencyInstance } = this.context;
        const currency = getCurrencyInstance(this.props.currency.toLowerCase());
        return (
            <div className={`balance ${currency.lowercaseCode()}`}>
                <div className="balance-title">
                    <div className="icon-currency">
                        <img src={images[`${currency.lowercaseCode()}Ball`]} alt={currency.code()}/>
                    </div>
                    {currency.asVerbose().toUpperCase()}
                </div>
                <div className="balance-quantity">
                    <MoneyField value={this.props.balance}
                                currency={currency.code()}
                                defaultValue={'--'}/>
                </div>
            </div>
        );
    }
}
